import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Button, message, Divider } from "antd";
import { FormOutlined, EditOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { TableCustom } from "../../components/table";
import { reducerRegister } from "../../helpers/reducers";
import { getAllPendingByCollaboratorIdApi } from "../../api/formsColaboradoresReleaseForms";

export const FormulariosColaboradoresPendencias = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);

  useEffect(() => {
    getAllPendingByCollaboratorId();
  }, []);

  const getAllPendingByCollaboratorId = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllPendingByCollaboratorIdApi();
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Campanha",
      dataIndex: "campanha",
    },
    {
      title: "Formulário",
      dataIndex: "formulario",
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Button
          loading={loading}
          onClick={() => navigate(`/formularios-colaboradores/pencencias/lancamento/${e.id}`)}
          icon={<EditOutlined />}>
          Responder
        </Button>
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={18} align="left">
          <div className="content-item">
            <HeaderPage title="Formulários Colaboradores" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Formulários Pendências"
              subtitle="Meus formulários"
              icon={<FormOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom loading={loading} columns={columns} dataSource={dados} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
